import { Feature } from '../core/access/interface';

export interface FeatureInformation {
  featureId: Feature;
  featureTitle: string;
  featureIcon: string;
  minUpgradeLevel?: string;
  shortDescription?: string;
  longDescriptionParagraphs?: string[];
}

export function getFeatureInformation(featureId: string): FeatureInformation {
  return RESTRICTED_FEATURE_CONTENT.filter((f) => f.featureId === featureId)[0];
}

export const RESTRICTED_FEATURE_CONTENT: FeatureInformation[] = [
  {
    featureId: Feature.lists,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.LISTS.TITLE',
    featureIcon: 'assignment',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.LISTS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.LISTS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.brands,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.BRANDS.TITLE',
    featureIcon: 'ico-brands',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.BRANDS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.BRANDS.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.BRANDS.LONG_DESCRIPTION_PARAGRAPHS_2',
    ],
  },
  {
    featureId: Feature.salesAndSuccessCenterAccess,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.SALES.TITLE',
    featureIcon: 'monetization_on',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.SALES.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.SALES.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.SALES.LONG_DESCRIPTION_PARAGRAPHS_2',
      'RESTRICTED_FEATURE_CONTENT.SALES.LONG_DESCRIPTION_PARAGRAPHS_3',
    ],
  },
  {
    featureId: Feature.prospects,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.PROSPECTS.TITLE',
    featureIcon: 'ico-hotness',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.PROSPECTS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.PROSPECTS.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.PROSPECTS.LONG_DESCRIPTION_PARAGRAPHS_2',
    ],
  },
  {
    featureId: Feature.salesTeam,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.SALES_TEAM.TITLE',
    featureIcon: 'group',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.SALES_TEAM.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.SALES_TEAM.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.SALES_TEAM.LONG_DESCRIPTION_PARAGRAPHS_2',
    ],
  },
  {
    featureId: Feature.snapshotBulkActivations,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.SNAPSHOT_BULK_ACTIVATIONS.TITLE',
    featureIcon: 'description',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.SNAPSHOT_BULK_ACTIVATIONS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.theLoop,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.THE_LOOP.TITLE',
    featureIcon: 'loop',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.THE_LOOP.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.THE_LOOP.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.salesOrders,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.SALES_ORDERS.TITLE',
    featureIcon: 'monetization_on',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.SALES_ORDERS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.SALES_ORDERS.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.SALES_ORDERS.LONG_DESCRIPTION_PARAGRAPHS_2',
    ],
  },
  {
    featureId: Feature.marketingAutomation,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.MARKETING_AUTOMATION.TITLE',
    featureIcon: 'email',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.MARKETING_AUTOMATION.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.MARKETING_AUTOMATION.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.contentLibrary,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.GUIDES.TITLE',
    featureIcon: 'library_books',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.GUIDES.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.GUIDES.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.snapshotWidget,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.SNAPSHOT_WIDGET.TITLE',
    featureIcon: 'widgets',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.SNAPSHOT_WIDGET.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.SNAPSHOT_WIDGET.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.concierge,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.CONCIERGE.TITLE',
    featureIcon: 'ico-task-manager',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.CONCIERGE.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.CONCIERGE.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.whitelabel,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.WHITELABEL.TITLE',
    featureIcon: 'style',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.WHITELABEL.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.WHITELABEL.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.publicStore,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.PUBLIC_STORE.TITLE',
    featureIcon: 'shopping_basket',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.PUBLIC_STORE.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.advancedAutomationTasks,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.ADVANCED_AUTOMATION_TASKS.TITLE',
    featureIcon: 'automation',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.ADVANCED_AUTOMATION_TASKS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.vendastaPayments,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.VENDASTA_PAYMENTS.TITLE',
    featureIcon: 'credit_card',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.VENDASTA_PAYMENTS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.VENDASTA_PAYMENTS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.automations,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.AUTOMATIONS.TITLE',
    featureIcon: 'offline_bolt',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.AUTOMATIONS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.AUTOMATIONS.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.AUTOMATIONS.LONG_DESCRIPTION_PARAGRAPHS_2',
    ],
  },
  {
    featureId: Feature.customFields,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.CUSTOM_FIELDS.TITLE',
    featureIcon: 'text_snippet',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.CUSTOM_FIELDS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.CUSTOM_FIELDS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.customizeBusinessApp,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.CUSTOMIZE_BUSINESS_APP.TITLE',
    featureIcon: 'store',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.CUSTOMIZE_BUSINESS_APP.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.CUSTOMIZE_BUSINESS_APP.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.serviceAccounts,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.SERVICE_ACCOUNTS.TITLE',
    featureIcon: 'fingerprint',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.SERVICE_ACCOUNTS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.SERVICE_ACCOUNTS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.metricsInsights,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.METRICS_INSIGHTS.TITLE',
    featureIcon: 'bar_chart',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.METRICS_INSIGHTS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.METRICS_INSIGHTS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.myProducts,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.MY_PURCHASES.TITLE',
    featureIcon: 'apps',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.MY_PURCHASES.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.MY_PURCHASES.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.MY_PURCHASES.LONG_DESCRIPTION_PARAGRAPHS_2',
    ],
  },
  {
    featureId: Feature.pipeline,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.SALES.TITLE',
    featureIcon: 'monetization_on',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.SALES.SHORT_DESCRIPTION',
    longDescriptionParagraphs: [
      'RESTRICTED_FEATURE_CONTENT.SALES.LONG_DESCRIPTION_PARAGRAPHS_1',
      'RESTRICTED_FEATURE_CONTENT.SALES.LONG_DESCRIPTION_PARAGRAPHS_2',
      'RESTRICTED_FEATURE_CONTENT.SALES.LONG_DESCRIPTION_PARAGRAPHS_3',
    ],
  },
  {
    featureId: Feature.goals,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.GOALS.TITLE',
    featureIcon: 'monetization_on',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.GOALS.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.GOALS.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.taskQueue,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.TASK_QUEUE.TITLE',
    featureIcon: 'assignment_turned_in',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.TASK_QUEUE.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.TASK_QUEUE.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
  {
    featureId: Feature.crmLeadProspector,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT.CRM_LEAD_PROSPECTOR.TITLE',
    featureIcon: 'my_location',
    shortDescription: 'RESTRICTED_FEATURE_CONTENT.CRM_LEAD_PROSPECTOR.SHORT_DESCRIPTION',
    longDescriptionParagraphs: ['RESTRICTED_FEATURE_CONTENT.CRM_LEAD_PROSPECTOR.LONG_DESCRIPTION_PARAGRAPHS_1'],
  },
];
